module.exports = __webpack_public_path__ + "static/media/valentina_guerrero_marin_rata.9f889c43.png";